import React, { useState, useEffect } from 'react';
import API_BASE_URL from '../apiBase';
import './VisitorsCounter.css';

const VisitorsCounter = () => {
  const [visitors, setVisitors] = useState({
    total: 0,
    today: 0,
    views: 0
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchVisitors = async () => {
      try {
        const response = await fetch(`${API_BASE_URL}/visitor_tracker.php`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        
        const text = await response.text();
        if (!text) {
          throw new Error('Empty response');
        }
        
        const data = JSON.parse(text);
        if (data.success) {
          setVisitors({
            total: data.total_visitors || 0,
            today: data.today_visitors || 0,
            views: data.total_views || 0
          });
        }
      } catch (error) {
        console.error('Error fetching visitors:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchVisitors();
    
    // Refresh every 30 seconds
    const interval = setInterval(fetchVisitors, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return (
      <div className="visitors-counter">
        <div className="visitors-counter-content">
          <i className="fas fa-users visitors-icon"></i>
          <span className="visitors-label">Visitors:</span>
          <span className="visitors-number">...</span>
        </div>
      </div>
    );
  }

  return (
    <div className="visitors-counter">
      <div className="visitors-counter-content">
        <i className="fas fa-users visitors-icon"></i>
        <span className="visitors-label">Visitors:</span>
        <span className="visitors-number">{visitors.total.toLocaleString()}</span>
      </div>
    </div>
  );
};

export default VisitorsCounter;
